import React, { useEffect, useState } from 'react'
import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { NULL_VALUE, SelectBox, typeValuesListItem } from 'components/UI/SelectBox/SelectBox'
import {
    IdPosConfigurationState,
    typePosConfigurationFilters
} from 'model/dashboardPosConfiguration/dPosConfigurationReducer'

import { getStoresListSlim } from 'model/dashboardStores/dStoresAPI'
import { getPosList } from 'model/dashboardPosConfiguration/dPosConfigurationAPI'
import { dPosConfigurationSetFiltersAC } from 'model/dashboardPosConfiguration/dPosConfigurationActionCreators'
import { Loader } from 'components/UI/Loader/Loader';


// Type
export type typeDPosConfigurationFilters = {
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const DPosFilters: React.FC<typeDPosConfigurationFilters> = ({ setOpenFilterBar, setIsActiveFilters }) => {

    const dispatch = useDispatch()

    // System data
    const filters = useSelector((state: { dPosConfiguration: IdPosConfigurationState }) => state.dPosConfiguration.filters)

    // Did mount
    useEffect(() => {
        setLoaderPos(true)
        setLoaderStore(true)
        const setData = async () => {

            let responseStores = await getStoresListSlim()

            if (responseStores.status === 200) {
                const newStoresList = [ ...selectStoreList, ...responseStores.data ]
                setSelectStoreList(newStoresList)
                setStoreIdValue(filters.storeId!)
            }

            let responsePOS = await getPosList()

            if (responsePOS.status === 200) {
                const newPOSList = [ ...selectPOSList, ...responsePOS.data.map((item: { id: string, posHardwareSerialNumber: string }) => ( {
                    id: item.id,
                    name: item.posHardwareSerialNumber,
                    label: item.posHardwareSerialNumber
                } )) ]
                setSelectPOSList(newPOSList)
                setPOSIdValue(filters.posId!)
            }
            setLoaderPos(false)
            setLoaderStore(false)
        }
        setData()
        // eslint-disable-next-line
    }, [])

    // Store SelectBox
    const [ storeIdValue, setStoreIdValue ] = useState<string>(NULL_VALUE.id)
    const [ selectStoreList, setSelectStoreList ] = useState<typeValuesListItem[]>([])
    const [loaderStore, setLoaderStore] = useState(false)

    // POS SelectBox
    const [ POSIdValue, setPOSIdValue ] = useState<string>(NULL_VALUE.id)
    const [ selectPOSList, setSelectPOSList ] = useState<typeValuesListItem[]>([])
    const [loaderPos, setLoaderPos] = useState(false)


    const checkIsChangedFiltersHandler = (newFilters: typePosConfigurationFilters): boolean => {
        // eslint-disable-next-line eqeqeq
        return !( newFilters.posId === filters.posId && newFilters.storeId === filters.storeId )
    }

    // Submit form
    const onSubmitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        const newFilters: typePosConfigurationFilters = {
            storeId: storeIdValue === NULL_VALUE.id ? null : storeIdValue,
            posId: POSIdValue === NULL_VALUE.id ? null : POSIdValue,
        }
        if (checkIsChangedFiltersHandler(newFilters)) {
            await dispatch(dPosConfigurationSetFiltersAC(newFilters))
            setIsActiveFilters(true)
        }
        setOpenFilterBar(false)
    }

    // Clear filters
    const onRestoreHandler = () => {
        setStoreIdValue(NULL_VALUE.id)
        setPOSIdValue(NULL_VALUE.id)
        setIsActiveFilters(false)
        dispatch(dPosConfigurationSetFiltersAC({storeId: null, posId: null}))
    }

    return (
        <>
            <form onSubmit={ (e) => onSubmitHandler(e) }>
                <div className="flex flex-col gap-4">

                    <div>
                        <div className="flex-grow relative">
                            <SelectBox
                                label={ <Trans>Store</Trans> }
                                valuesList={ selectStoreList }
                                valueId={ storeIdValue }
                                setIdValue={ setStoreIdValue }
                                labelClassname="text-left"
                            />
                            {loaderStore && <Loader/>}
                        </div>
                    </div>

                    <div>
                        <div className="flex-grow relative">
                            <SelectBox
                                label={ <Trans>POS SN</Trans> }
                                valuesList={ selectPOSList }
                                valueId={ POSIdValue }
                                setIdValue={ setPOSIdValue }
                                labelClassname="text-left"
                            />
                            {loaderPos && <Loader/>}
                        </div>
                    </div>

                    <div className="flex gap-4 mt-4">
                        <Button buttonClassName="w-full" secondary={ true } type="button" label={ <Trans>Clear</Trans> }
                                onClick={ onRestoreHandler }/>
                        <Button buttonClassName="w-full" type="submit" label={ <Trans>Apply</Trans> }/>
                    </div>

                </div>
            </form>
        </>
    )
}
